<template>
  <div class="header">
    <div class="mainSearchBox">
      <div class="mainSearch">
        <div class="serachInp">
          <el-input class="elIpt"  v-model="searchInput" @focus="historyDataOk" placeholder="输入疾病、方名、书名等"
                    @keyup.enter.native="search" @input="tishis"></el-input>
          <div class="inpList" v-show="tishiShow">

            <div class="searchlistData">
              <div class="searchInfoData" v-for="(item,index) in tishiData" :key="index">
                <div @click.stop="setVal(item)" style="cursor: pointer" v-html="setitemVal(item)">
                </div>
                <div></div>
              </div>
            </div>
          </div>
          <div class="inpList" v-show="historyShow">
            <div class="searchTishi">
              <div>搜索历史</div>
              <div></div>
              <div><span style="cursor: pointer" @click.stop="clearAll">清除全部 <img
                  src='../../assets/img/search/icon_清除_小.png' alt=""></span>
              </div>
            </div>
            <div class="searchlistData">
              <div class="searchInfoData"
                   v-for="(item,index) in historyData.length>0?historyData.length>1?historyData:historyData:[]"
                   :key="index">
                <div style="cursor: pointer" @click="setVal(item.name)"><img
                    src="../../assets/img/search/icon_历史搜索词条.png"
                    alt="">{{ item.name }}
                </div>
                <div><img style="cursor: pointer" src="../../assets/img/search/icon_清除历史搜索.png" alt=""
                          @click.stop="clears(index)"></div>
              </div>
            </div>
          </div>

          <el-button @click="search" class="elbtn">搜  索</el-button>

        </div>
        <div class="searchBtn"><span  style="cursor: pointer" @click="seniorSearch">高级搜索</span></div>
      </div>
    </div>
    <div class="hotSeniorBox">
      <div class="hotSenior">
          <span> 热门搜索：<span v-for="item in hotSerch" :key="item.id" style="margin-left: 10px;cursor: pointer"
                            @click="hotSearchVal(item.word)">{{ item.word }}</span></span>

      </div>
    </div>
  </div>
</template>

<script>
import {hotsearchApi, searchTipsAPI} from "@/util/axiosHttp";

export default {
  props:{
    searchVal:{
      type:String,
    }
  },
  data() {
    return {
      searchInput:"",
      scrollTop: null, // 页面被卷去的高度
      tishiShow:false,
      historyShow:false,
      tishiData: [],
      historyData: [],
      hotSerch:[

      ]
    };
  },
  mounted() {
    //////console.log(this.searchVal)
    this.searchInput = this.searchVal?this.searchVal:""
    this.inithotSearch()
  },
  methods:{
    tishis() {
      if (this.searchInput != '') {
        this.historyShow = false
        searchTipsAPI(this.searchInput).then((res) => {
          if (res.data.status_code == 200) {
            if(res.data.data.length>0){
              this.tishiShow = true
              this.tishiData = res.data.data;
            }else {
              this.tishiShow = false
            }
          }
        });
      }else {

        this.historyShow = true
      }
    },

    //进去到inp展示历史
    historyDataOk() {
      this.historyData = localStorage.getItem('historyData') ? JSON.parse(localStorage.getItem('historyData')) : []
      this.historyShow = true
      this.tishiShow = false
    },

    historyDataClear() {
      this.historyShow = false
      this.tishiShow = false
    },
    //清除全部
    clearAll() {
      this.historyData = []
      this.historyShow = true
      this.tishiShow = false
      localStorage.removeItem('historyData')
    },
    clears(index) {
      this.historyData.splice(index, 1);
      this.historyShow = true
      this.tishiShow = false
      localStorage.setItem("historyData", JSON.stringify(this.historyData));
    },
    setitemVal(item){
      return item.replaceAll(this.searchInput, `<span style="color:#cccccc">${this.searchInput}</span>`)
    },
    setVal(name) {
      console.log(name)
      this.searchInput = name
      this.search()
    },
    hotSearchVal(word){
      this.searchInput = word
      this.search()
    },

    inithotSearch() {
      hotsearchApi().then(res => {
        if (res.data.status_code == 200) {
          this.hotSerch = res.data.data
        }
      })
    },
    search(){
      this.$router.push({
        name:"searchInfo",
        query:{
          "searchInput":this.searchInput,
          "show":true,
        }
      })


      let data = localStorage.getItem("historyData")
          ? JSON.parse(localStorage.getItem("historyData"))
          : [];
      if (this.searchInput != "") {
        data.push({
          name: this.searchInput,
        });
      }
      for (let i = 0; i < data.length; i++) {
        for (let j = i + 1; j < data.length; j++) {
          if (data[i].name == data[j].name) {
            data.splice(j, 1)
          }
        }
      }
      localStorage.setItem("historyData", JSON.stringify(data));
    },

    seniorSearch(){
      this.$router.push({
        name:"advancedSearch",
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header{
  width: 100%;
  height:auto;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  box-shadow: 0px 1px 7px 0px rgba(0,0,0,0.12);
  //opacity: 0.88;
  .mainSearchBox{
    width: 100%;
    height: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
    .mainSearch{
      width: 820px;
      height: 60px;
      border-radius: 0 8px 8px 0;
      display: flex;
      .serachInp {
        width: 730px;
        background: #AC4B38;
        display: flex;
        border-radius: 0 8px 8px 0;
        position: relative;

        .elIpt {
          font-size: 16px;
          width: 624px;
          background: #FFFFFF;
          border: 5px solid #AC4B38;

          /deep/ .el-input__inner {
            height: 50px;
            border: none;
          }

          /deep/ .el-input__inner:focus {
            border: none;
          }
        }

        .inpList {
          width: 599px;
          height: auto;
          max-height: 270px;
          position: absolute;
          background: #fff;
          z-index: 199;
          top: 52px;
          display: flex;
          flex-direction: column;
          padding-left: 15px;
          padding-right: 15px;
          box-sizing: border-box;
          border-radius: 0 0 10px 10px;
          border-left:5px solid #ac4b38;
          border-right: 3px solid #ac4b38;
          border-bottom: 3px solid #ac4b38;

          .searchTishi {
            width: 100%;
            height: 60px;
            display: flex;

            div:nth-child(1) {
              width: 70px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 16px;
              font-family: PingFang-SC-Medium, PingFang-SC;
              font-weight: 500;
              color: #999;
            }

            div:nth-child(2) {
              flex: 1;
            }

            div:nth-child(3) {
              width: 90px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 13px;
              font-family: PingFang-SC-Regular, PingFang-SC;
              font-weight: 400;
              color: #999999;
            }
          }

          .searchlistData {
            flex: 1;
            overflow: auto;

            .searchInfoData {
              width: 100%;
              height: 40px;
              border-bottom: 1px solid #ccc;
              display: flex;

              div:nth-child(1) {
                flex: 1;
                display: flex;
                align-items: center;
                font-size: 14px;
                font-family: PingFang-SC-Medium, PingFang-SC;
                font-weight: 500;
                color: #333333;
                span{
                  color: #cccccc;
                }
                img{
                  width: 16px;
                  height: 16px;
                }
              }

              div:nth-child(2) {
                width: 40px;
                height: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }
          }

          .searchlistData::-webkit-scrollbar{
            width:0px;
            height:0px;
          }

        }

        .elbtn {
          width: 136px;
          background: #AC4B38;
          border: none;
          color: #fff;
          font-size: 18px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          color: #FFFFFF;
          line-height: 25px;
        }

        .elbtn:hover {
          width: 136px;
          background: #AC4B38;
          border: none;
          opacity: 0.8;
          color: #fff;
          font-size: 18px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          color: #FFFFFF;
          line-height: 25px;
        }
      }
      .searchBtn{
        width: 72px;
        height: 25px;
        font-size: 18px;
        font-family: PingFang-SC-Bold, PingFang-SC;
        color: #AC4B38;
        margin-left: 8px;
        line-height: 60px;
      }
    }
  }
  .hotSeniorBox{
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .hotSenior{
      width: 820px;
      height: 30px;
      margin-top: 8px;
      text-align: left;
      font-size: 16px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      color: #666666;
      a:hover{
        border-bottom: 1px solid black;
      }
    }
  }

}
</style>
